import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { CommonService } from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe, DecimalPipe } from '@angular/common';
import { AMPubscriptionModel, GetAMPSubscription, IAMPAutorenewal, IAMPCustomerDetailsViewModel, IAMPModifySubscriptionResponse, IAMPSubscriptionDetail } from '../../../../models/amp.model';
import { AdobeService } from '../../../../services/adobe.service';
import { format } from 'date-fns';
import { AuthService } from '../../../../services/auth.service';
import { ConfirmAMPQtyComponent } from '../../../../popup-collection/confirm-amp-qty/confirm-amp-qty.component';
import { ConfirmAMPSubscriptionPopup } from '../../../../popup-collection/confirm-amp-subscription-popup/confirm-amp-subscription-popup.component';
import { FinishAMPSubscriptionComponent } from '../../../../popup-collection/finish-amp-subscription/finish-amp-subscription.component';
import { SimpleMsgPopupComponent } from '../../../../popup-collection/simple-msg/simple-msg-popup.component';
import { ManageService } from '../../../../services/manage.service';


@Component({
  selector: 'app-manage-amp-subscription',
  templateUrl: './manage-amp-subscription.component.html',
  styleUrls: ['./manage-amp-subscription.component.css'],
  providers: [DecimalPipe]
})
export class ManageAMPSubscriptionComponent implements OnInit, OnDestroy, AfterViewInit {

  public title = 'Manage Subscription';
  public detail: IAMPSubscriptionDetail = {} as IAMPSubscriptionDetail;

  public customerDetails: IAMPCustomerDetailsViewModel;
  public ampSubs: GetAMPSubscription[] = [];

  public showStatusToggleSpinner = true;
  public showSerialSpinner = true;
  public subscriptionTableView: GetAMPSubscription;

  private customerId: string;
  private subscriptionId: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public expiryDate: string;
  public currentQty: number;
  public qtyChanged = false;
  public isCancelable: boolean = false;
  public isCanceling: boolean = false;
  public isAddingLicense: boolean = false;
  public autoRenewLoading = false;
  public renewalLoading = false;
  public renewalIsToday = false;
  public isRenewLoaded = false;
  currentLineItemId: number;
  loadContent: boolean = false;

  public loadingTransitionEligibilities = false;
  public transitionEligibilitiesLoaded = false;

  public ampManageSubForm = this.fb.group({
    addLicensesQty: [null],
    autoRenewalEnabled: [{ value: false }],
    toQty: ['']
  });

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      setTimeout(() => {
        if (!$('#AMPSubscriptionCancellationComponent').length) {
          $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
        }
      }, 100);
    });
  }

  constructor(
    private adobeService: AdobeService,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    private _decimalPipe: DecimalPipe,
    private _datePipe: DatePipe,
    public commonService: CommonService,
    public authService: AuthService
  ) { }

  ngOnInit() {
      combineLatest([
        this.activatedRoute.parent.params,
        this.activatedRoute.params,
        this.adobeService.getCurrentAMPSubscriptions,
        this.adobeService.currentAMPCustomerDetailsWatch
      ])
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(([tenantParams, subParams, subs, customer]) => {


          this.customerDetails = customer;
          this.customerId = tenantParams['tenantId'];
          this.subscriptionId = subParams['subId'];
          this.currentLineItemId = subs.length + 1;
          this.ampSubs = [ ...subs ];
          if (subs?.length) {
            let sub = subs.find(s => s.out_subscription_id ==  this.subscriptionId);
            if (sub) {
              this.subscriptionTableView = sub;
              this.getAMPSubscriptionDetail();

              if (!this.authService?.currentUserHasPurchaseAccess()) {
                this.ampManageSubForm.get('addLicensesQty').disable();
                this.ampManageSubForm.get('autoRenewalEnabled').disable();
                this.ampManageSubForm.get('toQty').disable();
              }
    
            }
          }
        });
  }

  private getAMPSubscriptionDetail() {
    this.autoRenewLoading = true
    this.adobeService.getAMPSubscriptionDetail(this.customerId, this.subscriptionId)
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe((detail: IAMPSubscriptionDetail) => {
        if (!this.commonService.isEmpty(detail)) {
          this.detail = detail

          // 14 days from creatation day check
          this.isCancelable = new Date().getTime() + (14 * 24 * 60 * 60 * 1000) > new Date(this.detail.creationDate).getTime()

          this.currentQty = this.detail?.currentQuantity
          this.ampManageSubForm.get('autoRenewalEnabled').setValue(this.detail?.autoRenewal?.enabled)

          // const today = new Date();
          // const disableDate = new Date(today.setMonth(today.getMonth() + 12));
          // let renewalDate = new Date(this.detail?.renewalDate);
          // if (this.is3YC()) {
          //   renewalDate = new Date(this.detail?.creationDate);
          //   renewalDate.setFullYear(renewalDate.getFullYear() + 3);
          // }
          // if ((+renewalDate - +disableDate) > 0) this.ampManageSubForm.get('autoRenewalEnabled').disable();

          this.ampManageSubForm.get('toQty').setValue(this.detail?.autoRenewal?.renewalQuantity)
          this.isRenewLoaded = true;
          this.autoRenewLoading = false;
          // this.manageService.updateWGSdetailView$.next(detail)
          // this.statusToggleButton.setValue(!this.detail?.subscriptionStatus.toLowerCase().includes('suspend'));
          // this.statusToggleButton.enable();
          // this.showStatusToggleSpinner = false;
          // this.showSerialSpinner = false;
        }
      }, (error: any) => {
        this.commonService.implementToast(error, 'Error');
      })
  }

  private getStockcode(): string {
    if (this.subscriptionTableView?.out_stock_code?.includes(':')) {
      return this.subscriptionTableView?.out_stock_code.split(':')[0];
    } else {
      return this.subscriptionTableView?.out_stock_code;
    }
  }

  public addLicenses(): void {
    const effectiveDate = this.customerDetails?.customer?.three_year_commitment_status.toLocaleLowerCase() == 'committed' ? this._datePipe.transform(this.customerDetails?.customer?.three_year_commitment_start_date, 'dd-MM-yyyy') : null;

    const previewItem = {
      tenantId: this.customerId,
      parentSubscriptionId: '',
      subscriptionId: this.subscriptionId,
      stockCode: this.getStockcode(),
      qty: this.ampManageSubForm.get('addLicensesQty').value?.toString(),
      currentQty: this._decimalPipe.transform(this.subscriptionTableView.out_qty, '1.0-0')?.toString(),
      subscriptionDescription: this.subscriptionTableView.out_stk_description,
      status: '',
      stockGroup: this.subscriptionTableView.out_stock_group,
      lineItemId: this.currentLineItemId.toString(),
      orderType: 'PREVIEW',
      inEffectivePriceDate: effectiveDate,
    } as AMPubscriptionModel;

    this.isAddingLicense = true;
    this.adobeService.createOrCancelAMPSubscription([previewItem]).subscribe((res: IAMPModifySubscriptionResponse[]) => {
      this.isAddingLicense = false;
      if (res.length) {

        if (res[0].message === 'Product not found') {
          this.commonService.implementToast("Product not found", "Error");
        } else if (res[0].isUpdateSuccessful) {
          const daysDiff = Math.ceil((new Date(this.detail?.renewalDate).getTime() - this.commonService.getPDTDate().getTime()) / (1000 * 3600 * 24));
          const pricePerDay: number = 
              this.commonService.toNumber(res[0].unitPrice.replace('$', '').replace(',', '')) / 
              (this.commonService.ignoreLeapYearDay() ? 365 : 366);
          const totalPrice: number = this.commonService.currencyRounding(
            this.commonService.toNumber(this.ampManageSubForm.get('addLicensesQty').value) * daysDiff * pricePerDay
          );
 
          const dialogRef = this.dialog.open(ConfirmAMPSubscriptionPopup, {
            width: '650px',
            data: { totalPriceChange: totalPrice, hasProrated: true }
          });
      
          dialogRef.afterClosed().subscribe(result => {
      
            if (result) {
              previewItem.orderType = "NEW";
              previewItem.customerReference = result;
              previewItem.stockCode = res[0].stockDescription;

              this.loadContent = this.isAddingLicense = true;
              this.adobeService.createOrCancelAMPSubscription([previewItem])
                .pipe(takeUntil(this.ngUnsubscribe))
                .pipe(finalize(() => this.loadContent = this.isAddingLicense = false))
                .subscribe(
                  (res: IAMPModifySubscriptionResponse[]) => {
                    if (res.length) {
                      const dialogRefFinish = this.dialog.open(FinishAMPSubscriptionComponent, {
                        width: '650px',
                        data: { finishSubscriptions: res, confirmSubscriptions: [previewItem]},
                        disableClose: true
                      });
              
                      dialogRefFinish.afterClosed().subscribe(() => {
                        this.manageService.getOrRefreshSubscriptionOrderSubject.next();
                        this.adobeService.refetchAMPItemsView$.next();
                        this.getAMPSubscriptionDetail();
                        // this.subscriptionItemsPendingList = [];
                        // this.totalPriceChange = 0;
                        // this.pendingTotal = 0;
                        // this.adobeService.monitorAMPPendingSubscriptions([]);
                        // this.adobeService.refetchAMPItemsView$.next();
                        // if (!this.cotermDate) this.adobeService.refetchAMPTenantDetailView$.next();
                        // let urlArr = this.router.url.split("/", 6).slice(1);
                        // this.router.navigate([urlArr.join("/")]);
                        // $('#levelOne').animate({ scrollLeft: 250 }, 400);
                      });
                    }
                  },
                  (error: string) => {
                    this.commonService.implementToast(error, "Error");
                  }
              );

            }
          });      
        } else {
          this.commonService.implementToast(res[0].message, 'Error')
        }
      }
    });
  }

  public getStatus(status: string) {
    if (status == '1000') return 'Active';
    if (status == '1002') return 'Pending Fulfilment';
    return ''
  }

  toggleAutoRenew(event: any) {
    if (this.ampManageSubForm.get('autoRenewalEnabled').value !== true) {
      const licenseQty = parseInt(this.customerDetails?.customer?.license_discount_level)
      const totalQty = this.ampSubs.reduce((accumulator, sub) => {
        if (sub.out_subscription_id ==  this.subscriptionId) {
          return accumulator + parseInt(this.ampManageSubForm.get('toQty').value)
        }
        return accumulator + parseInt(sub.out_qty)
      }, 0);

      if (this.is3YC() && (totalQty < licenseQty)) {
        this.dialog.open(SimpleMsgPopupComponent, {
          width: '400px',
          data: {
            title: 'Committed License Qty',
            msg: 'Your committed license quantity is more than current qty, please increase other sub qty to reduce this sub qty.'
          }
        }).afterClosed().subscribe(() => {
          this.updateAMPRenewal();
        })
      } else {
        this.updateAMPRenewal();
      }
    } else {
      this.updateAMPRenewal();
    }
  }

  private updateAMPRenewal(): void {
    const autoRenewal = {
      enabled: this.ampManageSubForm.get('autoRenewalEnabled').value,
      renewalQuantity: this.ampManageSubForm.get('toQty').value
    } as IAMPAutorenewal
    this.adobeService.updateAMPRenewal(this.customerId, this.subscriptionId, { autoRenewal })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          if (res?.hasError) {
            this.commonService.implementToast(res.errorMessage, "Error");
            this.ampManageSubForm.get('autoRenewalEnabled').setValue(!this.ampManageSubForm.get('autoRenewalEnabled').value);
          } else {
            this.manageService.getOrRefreshSubscriptionOrderSubject.next();
            this.adobeService.refetchAMPItemsView$.next();
            if (this.ampManageSubForm.get('autoRenewalEnabled').value) {
              this.commonService.implementToast(`Auto-renew has been successfully turned ON`, "Success");
            } else {
              this.commonService.implementToast(`Auto-renew has been successfully turned OFF`, "Success");
            }
          }
        },
        error: (err) => {
          this.commonService.implementToast(err, "Error")
          this.ampManageSubForm.get('autoRenewalEnabled').setValue(!this.ampManageSubForm.get('autoRenewalEnabled').value);
        },
        complete: () => this.autoRenewLoading = false
      })
  }

  onQtyTyping(event: any) {
    if (event.key < 0 && event.target.value == "") {
      event.preventDefault();
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  updateQty() {

    let targetQty = this.ampManageSubForm.get('toQty').value
    let currenAmount: number;
    let additionalAmount: number;
    let nextBillingAmount: number;
    this.qtyChanged = Number(targetQty) !== Number(this.detail?.autoRenewal?.renewalQuantity);
    if (this.ampManageSubForm.get('toQty').value) {
      if (this.qtyChanged && (this.ampManageSubForm.get('autoRenewalEnabled').value)) {
        currenAmount = (Number(this.subscriptionTableView.out_price) * this.currentQty);

        let remainingDays = this.commonService.getDateDiffInDays(new Date(), new Date(this.expiryDate));
        let additionalQty = targetQty - this.currentQty;
        let additionalAmount = (remainingDays / (this.commonService.isLeapYear(new Date().getFullYear()) ? 366 : 365)) * additionalQty * Number(this.subscriptionTableView.out_price);
        let newTermAmount = (Number(this.subscriptionTableView.out_price) * targetQty);

        // check license qty
        const licenseQty = parseInt(this.customerDetails?.customer?.license_discount_level)
        const totalQty = this.ampSubs.reduce((accumulator, sub) => {
          if (sub.out_subscription_id ==  this.subscriptionId) {
            return accumulator + parseInt(targetQty)
          }
          return accumulator + parseInt(sub.out_qty)
        }, 0);

        if (this.is3YC() && (totalQty < licenseQty)) {
          this.dialog.open(SimpleMsgPopupComponent, {
            width: '400px',
            data: {
              title: 'Committed License Qty',
              msg: 'Your committed license quantity is more than current qty, please increase other sub qty to reduce this sub qty.'
            }
          })
        } else {
          //show popup
          const dialogRef = this.dialog.open(ConfirmAMPQtyComponent, {
            width: '650px',
            data: {
              currenAmount: currenAmount,
              additionalAmount: additionalAmount,
              nextBillingAmount: nextBillingAmount,
              newTermAmount: newTermAmount,
              autorenew: this.ampManageSubForm.get('autoRenewalEnabled').value
            }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result != undefined && result.action == 'ScheduleNew') {
              this.autoRenewLoading = true;
              const autoRenewal = {
                enabled: this.ampManageSubForm.get('autoRenewalEnabled').value,
                renewalQuantity: this.ampManageSubForm.get('toQty').value,
                renewalCode: this.detail?.autoRenewal?.renewalCode,
              } as IAMPAutorenewal
              this.adobeService.updateAMPRenewal(
                this.customerId,
                this.subscriptionId,
                {autoRenewal}
              ).subscribe(
                (res) => {
                  if (res?.hasError) {
                    this.commonService.implementToast(res.errorMessage, "Error");
                    this.ampManageSubForm.get('toQty').setValue(Number(this.currentQty));
                    this.qtyChanged = false;
                  } else {
                    this.manageService.getOrRefreshSubscriptionOrderSubject.next();
                    this.adobeService.refetchAMPItemsView$.next();
                    this.commonService.implementToast(`Qty updated successfully`, "Success");
                  }
                },
                (error: any) => {
                  this.commonService.implementToast(error, "Error")
                  this.ampManageSubForm.get('toQty').setValue(Number(this.currentQty));
                  this.qtyChanged = false;
                }
              ).add(() => {
                this.autoRenewLoading = false;
              });
              return;
            }
            if (result != undefined && result.action == 'Close') {
              this.ampManageSubForm.get('toQty').setValue(Number(this.currentQty));
              this.qtyChanged = false;
              return;
            }
          })
        }
      }
    } else {
      this.ampManageSubForm.get('toQty').setValue(Number(this.currentQty));
      this.commonService.implementToast('Zero quantity is not allowed', 'Error');
    }


  }
  
  navToCancelPage() {
    this.router.navigate([`Cancellation/${this.subscriptionTableView?.out_stock_code}`], { relativeTo: this.activatedRoute });
  }

  public getAutoRenwewalText(autoRenewalEnabled: boolean): string {   
    let renewalDate = new Date(this.detail?.renewalDate);
    let expiryDate = new Date(this.subscriptionTableView?.out_expiry_date);
    if (this.is3YC()) {    
      /* renewalDate = new Date(this.detail?.creationDate);          
         renewalDate.setFullYear(renewalDate.getFullYear() + 3);*/ 
      const renewDateAddDay = new Date(this.customerDetails?.customer?.three_year_commitment_end_date);
      renewDateAddDay.setDate(renewDateAddDay.getDate() + 1);
      renewalDate = new Date(renewDateAddDay);
    }    
    if (autoRenewalEnabled) {
      return `RENEWS ON ${format(renewalDate, 'dd-MMM-yyyy')}`
    } else {
      return `EXPIRY ON ${format(expiryDate, 'dd-MMM-yyyy')}`
    }
  }

  public getAutoRenwewalDate(): string {
    if (this.isRenewLoaded) {
      let expiryDate = new Date(this.subscriptionTableView?.out_expiry_date);
      // if (this.is3YC()) {
      //   expiryDate = new Date(this.detail?.creationDate);
      //   expiryDate.setFullYear(expiryDate.getFullYear() + 3);
      // }
      return `${format(expiryDate, 'dd-MMM-yyyy')}`;
    }
    return '';
  }

  public is3YC(): boolean {
    return (this.customerDetails?.customer?.is_3y_commit) && (['ACCEPTED', 'COMMITTED'].includes(this.customerDetails?.customer?.three_year_commitment_status));
  }

  public getTransitionEligibilities(): void {
    // UPGRADE OPTIONS
    // if (this.subscriptionId) {
    //   this.loadingTransitionEligibilities = true;
    //   this.manageService.GetTransitionEligibilities(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toLocaleLowerCase())
    //     .pipe(takeUntil(this.ngUnsubscribe))
    //     .subscribe((data: any) => {
    //       data.forEach(ele => {
    //         if (ele.eligibilities.some(eligibility => eligibility.isEligible == true)) {
    //           this.transitionEligibilities.push(ele);
    //         }
    //         if (ele.catalogItemId == this.catalogItemId) {
    //           this.mceRenewalData.to = ele;
    //           this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
    //         }
    //       });
    //       this.transitionEligibilitiesFilters = this.transitionEligibilities.slice();
    //       this.loadingTransitionEligibilities = false;
    //       this.transitionEligibilitiesLoaded = true;
    //     });
    // }
  }

  close() {
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/AMP/AMPDetails/' + this.customerId);
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
